import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  Button, Icon, message, Spin,
} from 'antd';
import { faUser } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import BackgroundColorContainer from '../components/other/BackgroundColorContainer';
import { Box, ShowIf, Text } from '../../shared/components';
import GiotalkHeader from '../components/other/GiotalkHeader';
import { chatSeleccionadoSelector } from '../../../state/selectors/giotalk.selectors';
import TwoColumnsFlexLayout from '../../shared/components/layout/TwoColumnsFlex.layout';
import { usuariosMappedByIdSelector } from '../../../state/selectors/usuarios.selectors';
import { abandonarChat, abrirChatConUsuario, establecerChatIdActual } from '../../../state/actions/creators/giotalk.actioncreator';
import { handleSagaStatus, obtenerEstadoRequestDesdeSaga } from '../../../helpers/sagaStatus.helper';

class GiotalkChatParticipantesPage extends Component {

  componentDidMount() {
    const { match, establecerChatIdActual } = this.props;
    const { params } = match;
    const { chatId: id } = params;
    establecerChatIdActual({ id });

    const { chat, history } = this.props;
    if (chat === null || chat === undefined) history.replace('/talk');
  }

  abandonarGrupo() {
    const { chat, abandonarChat } = this.props;
    const { id } = chat;
    abandonarChat({ chatId: id });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { abandonarChatStatus: previousAbandonarChatStatus } = prevProps;
    const { abandonarChatStatus } = this.props;
    const { history } = this.props;

    handleSagaStatus({
      estadoPeticion: abandonarChatStatus,
      previousEstadoPeticion: previousAbandonarChatStatus,
      onWasRunningAndHasSucceded: () => {
        history.replace('/talk');
      },
      onWasRunningAndHasFailed: () => {
        message.error('Ha ocurrido un problema al intentar abandonar el grupo');
      },
    });
  }

  enviarMensajeAUsuario(usuario) {
    const { abrirChatConUsuario } = this.props;
    abrirChatConUsuario({ usuario });
  }

  render() {
    const {
      chat, history, usuariosMapped, abandonarChatStatus,
    } = this.props;
    if (chat === null || chat === undefined) return <div />;
    const { id: chatId, nombre, usuarios } = chat;
    const { empresaUsuarioActual, usuarioIdActual } = this.props;
    const { running: abandonandoGrupo } = abandonarChatStatus;
    const editarMiembrosLink = `/talk/chats/${chatId}/editarMiembros`;
    const requestPending = abandonandoGrupo;
    const usuariosJSX = usuarios.map((usuario) => {
      const { intUser, company } = usuario;
      const soyYo = company !== undefined && intUser !== undefined && company == empresaUsuarioActual && usuarioIdActual == intUser;

      const extendedUserInfo = usuariosMapped[intUser];
      const { nombreCompleto: nombreUsuario } = extendedUserInfo || { nombreCompleto: '' };
      const { tienda } = extendedUserInfo || { tienda: { nombre: '' } };
      const { nombre: nombreTienda } = tienda;

      return (
        <TwoColumnsFlexLayout
          pb="32"
          key={intUser}
          flexLeft={4}
          flexRight={1}
          leftContent={(
            <Box>
              <FontAwesomeIcon icon={faUser} color="lightgrey" />
              {' '}
              <Text ml="8" color="white">
                {nombreUsuario}
                <ShowIf condition={soyYo}>
                  <Text ml="8">(Yo)</Text>
                </ShowIf>
              </Text>
              <Text mt="8" fontSize="12" color="lightgrey" display="block">{nombreTienda}</Text>
            </Box>
          )}
          rightContent={(
            <Box>
              <ShowIf condition={soyYo}>
                <ShowIf condition={abandonandoGrupo === true}>
                  <Spin
                    style={{ margin: 'auto auto', display: 'block', color: 'white' }}
                    indicator={
                      <Icon type="loading" style={{ fontSize: 32 }} spin />
                    }
                  />
                </ShowIf>
                <ShowIf condition={abandonandoGrupo !== true}>
                  <Button onClick={() => this.abandonarGrupo()} block type="link">
                    <Text fontSize="12">
                      Dejar el grupo
                    </Text>
                  </Button>
                </ShowIf>
              </ShowIf>
              <ShowIf condition={false}>
                <Button disabled={requestPending} block type="link" onClick={() => this.enviarMensajeAUsuario(usuario)}>
                  <Text
                    fontSize="12"
                  >
                    Enviar mensaje
                  </Text>
                </Button>
              </ShowIf>
            </Box>
          )}
        />
      );
    });

    return (
      <BackgroundColorContainer color="#063340">
        <Box p="16">
          <GiotalkHeader
            onBackButtonPressed={() => history.goBack()}
            title="Participantes"
            subtitle={(
              <Text
                style={{
                  maxWidth: '100%',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                }}
                fontSize="12"
                color="lightgrey"
              >
                {nombre}
              </Text>
            )}
          />
        </Box>

        <Box px="16">
          {usuariosJSX}
        </Box>

        <Box p="16">
          <Link to={editarMiembrosLink}>
            <Button ghost block disabled={requestPending}> Añadir miembros</Button>
          </Link>
        </Box>

      </BackgroundColorContainer>
    );
  }
}

const mapStateToProps = (state) => {
  const { auth: { user }, sagas } = state;
  const {
    cliente_deipe: empresa,
    user_info: { usuario_id: usuarioId },
  } = user || { cliente_deipe: undefined, user_info: { cliente_deipe: undefined, usuarioId: undefined } };

  return {
    chat: chatSeleccionadoSelector(state),
    usuariosMapped: usuariosMappedByIdSelector(state),
    empresaUsuarioActual: empresa,
    usuarioIdActual: usuarioId,
    abandonarChatStatus: obtenerEstadoRequestDesdeSaga(sagas, 'GIOTALK_ABANDONAR_CHAT'),
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    abandonarChat,
    abrirChatConUsuario,
    establecerChatIdActual,
  }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GiotalkChatParticipantesPage);

GiotalkChatParticipantesPage.propTypes = {};
